export default "__VITE_ASSET__DM$oejba__"